import useId from '../utils/useId';
import * as React from 'react';
export const googleSvg = React.forwardRef(function googleSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  const id_5 = baseId + '_5';
  const id_6 = baseId + '_6';
  const id_7 = baseId + '_7';
  const id_8 = baseId + '_8';
  const id_9 = baseId + '_9';
  const id_10 = baseId + '_10';
  const id_11 = baseId + '_11';
  const id_12 = baseId + '_12';
  const id_13 = baseId + '_13';
  const id_14 = baseId + '_14';
  const id_15 = baseId + '_15';
  const id_16 = baseId + '_16';
  const id_17 = baseId + '_17';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'mask',
      {
        id: `bi_google__a_${id_0}`,
        style: {
          maskType: 'luminance',
        },
        maskUnits: 'userSpaceOnUse',
        x: 4,
        y: 4,
        width: 24,
        height: 24,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M27.523 13.774H16.25v4.613h6.478a5.525 5.525 0 0 1-2.055 3.452c-1.49 1.166-3.225 1.404-4.43 1.404-3.046 0-5.649-2.01-6.656-4.742-.04-.1-.068-.202-.1-.303a7.185 7.185 0 0 1 .027-4.476c.947-2.84 3.608-4.962 6.73-4.962.628 0 1.233.076 1.807.229a6.473 6.473 0 0 1 2.806 1.575l3.427-3.428C22.2 5.183 19.481 4 16.24 4c-2.592 0-4.985.825-6.946 2.219a12.008 12.008 0 0 0-3.775 4.402 11.878 11.878 0 0 0-1.267 5.378c0 1.942.449 3.767 1.268 5.382v.01a12.128 12.128 0 0 0 3.666 4.317A11.907 11.907 0 0 0 16.24 28c1.9 0 3.583-.35 5.068-1.005a10.355 10.355 0 0 0 2.879-1.883 10.627 10.627 0 0 0 2.631-3.833c.607-1.491.932-3.177.932-5.004 0-.851-.084-1.716-.226-2.501Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        mask: `url(#bi_google__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__b_${id_1})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M4.078 16.08c.013 1.912.546 3.884 1.353 5.476v.011c.583 1.156 1.38 2.07 2.288 2.975l5.484-2.044c-1.038-.538-1.196-.868-1.94-1.47a7.115 7.115 0 0 1-1.679-2.735H9.57l.014-.01c-.232-.696-.255-1.435-.263-2.203H4.078Z',
          fill: `url(#bi_google__c_${id_2})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__d_${id_3})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16.25 3.913c-.542 1.945-.335 3.835 0 4.935a7.03 7.03 0 0 1 1.8.228 6.472 6.472 0 0 1 2.806 1.576l3.516-3.516c-2.083-1.95-4.589-3.22-8.122-3.223Z',
          fill: `url(#bi_google__e_${id_4})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__f_${id_5})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16.238 3.897a12.25 12.25 0 0 0-7.124 2.276A12.324 12.324 0 0 0 7.072 8c-.16 1.532 1.196 3.415 3.883 3.4 1.303-1.55 3.231-2.551 5.377-2.551h.006l-.088-4.95h-.012Z',
          fill: `url(#bi_google__g_${id_6})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__h_${id_7})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M25.013 16.635 22.64 18.3a5.446 5.446 0 0 1-.68 1.88 5.525 5.525 0 0 1-1.375 1.572c-1.486 1.163-3.217 1.402-4.422 1.403-1.246 2.167-1.465 3.253.087 5.002 1.92-.002 3.623-.355 5.125-1.018a10.494 10.494 0 0 0 2.917-1.908 10.77 10.77 0 0 0 2.667-3.885c.615-1.511.944-3.22.944-5.071l-2.89.36Z',
          fill: `url(#bi_google__i_${id_8})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__j_${id_9})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16.075 13.598v4.965h11.417c.1-.68.432-1.56.432-2.288 0-.851-.083-1.891-.225-2.677H16.075Z',
          fill: '#3086FF',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__k_${id_10})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M7.126 7.824a11.973 11.973 0 0 0-1.783 2.621c-.819 1.63-1.267 3.612-1.267 5.554l.002.082c.363.71 5.009.574 5.243 0 0-.027-.003-.053-.003-.08 0-.797.131-1.384.371-2.104a7.374 7.374 0 0 1 1.354-2.411c.134-.175.493-.552.598-.779.04-.086-.073-.134-.08-.164-.006-.034-.157-.007-.19-.032-.107-.08-.32-.122-.448-.16-.275-.079-.731-.254-.984-.436-.8-.575-2.05-1.262-2.813-2.091Z',
          fill: `url(#bi_google__l_${id_11})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__m_${id_12})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M9.956 10.546c1.856 1.149 2.39-.58 3.624-1.12l-2.147-4.547a12.052 12.052 0 0 0-4.929 3.905l3.452 1.762Z',
          fill: `url(#bi_google__n_${id_13})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_google__o_${id_14})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M10.712 22.147c-2.492.919-2.882.952-3.111 2.529.438.437.909.84 1.41 1.207 1.342.983 3.925 2.292 7.228 2.292h.011v-5.108h-.007c-1.237 0-2.226-.331-3.24-.908-.25-.142-.703.24-.933.069-.318-.236-1.083.203-1.358-.081Z',
          fill: `url(#bi_google__p_${id_15})`,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          opacity: 0.5,
          filter: `url(#bi_google__q_${id_16})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M14.791 22.907v5.18c.462.055.943.088 1.448.088.506 0 .995-.026 1.47-.075v-5.159a8.58 8.58 0 0 1-1.467.127c-.498 0-.982-.06-1.451-.161Z',
          fill: `url(#bi_google__r_${id_17})`,
        }),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__b_${id_1}`,
          x: 4.037,
          y: 16.039,
          width: 9.207,
          height: 8.544,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__d_${id_3}`,
          x: 15.876,
          y: 3.872,
          width: 8.537,
          height: 6.822,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__f_${id_5}`,
          x: 7.018,
          y: 3.856,
          width: 9.361,
          height: 7.583,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__h_${id_7}`,
          x: 15.116,
          y: 16.233,
          width: 12.829,
          height: 11.965,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__j_${id_9}`,
          x: 16.034,
          y: 13.557,
          width: 11.931,
          height: 5.047,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__k_${id_10}`,
          x: 4.034,
          y: 7.783,
          width: 7.656,
          height: 8.822,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__m_${id_12}`,
          x: 6.215,
          y: 4.589,
          width: 7.655,
          height: 6.632,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.145,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__o_${id_14}`,
          x: 7.559,
          y: 22.085,
          width: 8.732,
          height: 6.131,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_google__q_${id_16}`,
          x: 14.75,
          y: 22.865,
          width: 3.001,
          height: 5.351,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 0.021,
          result: 'effect1_foregroundBlur_22_698',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__c_${id_2}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'matrix(-.4883 -11.95193 17.55595 -.71724 13.093 24.362)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.142,
          stopColor: '#1ABD4D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.248,
          stopColor: '#6EC30D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.312,
          stopColor: '#8AC502',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.366,
          stopColor: '#A2C600',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.446,
          stopColor: '#C8C903',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.54,
          stopColor: '#EBCB03',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.616,
          stopColor: '#F7CD07',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.699,
          stopColor: '#FDCD04',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.771,
          stopColor: '#FDCE05',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.861,
          stopColor: '#FFCE0A',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__e_${id_4}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientTransform:
            'matrix(8.29245 -.00002 -.00001 10.7093 24.043 10.398)',
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.408,
          stopColor: '#FB4E5A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FF4540',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__g_${id_6}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'matrix(-11.61833 6.43485 -8.73208 -15.76606 19.514 2.347)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.231,
          stopColor: '#FF4541',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.312,
          stopColor: '#FF4540',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.458,
          stopColor: '#FF4640',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.54,
          stopColor: '#FF473F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.699,
          stopColor: '#FF5138',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.771,
          stopColor: '#FF5B33',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.861,
          stopColor: '#FF6C29',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FF8C18',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__i_${id_8}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'rotate(-127.454 14.778 9.248) scale(34.6477 12.7893)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.132,
          stopColor: '#0CBA65',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.21,
          stopColor: '#0BB86D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.297,
          stopColor: '#09B479',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.396,
          stopColor: '#08AD93',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.477,
          stopColor: '#0AA6A9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.568,
          stopColor: '#0D9CC6',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.667,
          stopColor: '#1893DD',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.769,
          stopColor: '#258BF1',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.859,
          stopColor: '#3086FF',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__l_${id_11}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'matrix(-1.4911 12.8522 -17.7704 -2.0617 15.22 6.164)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.366,
          stopColor: '#FF4E3A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.458,
          stopColor: '#FF8A1B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.54,
          stopColor: '#FFA312',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.616,
          stopColor: '#FFB60C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.771,
          stopColor: '#FFCD0A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.861,
          stopColor: '#FECF0A',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.915,
          stopColor: '#FECF08',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FDCD01',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__n_${id_13}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'rotate(132.119 5.223 5.929) scale(6.42638 18.1259)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.316,
          stopColor: '#FF4C3C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.604,
          stopColor: '#FF692C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.727,
          stopColor: '#FF7825',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.885,
          stopColor: '#FF8D1B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FF9F13',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'radialGradient',
        {
          id: `bi_google__p_${id_15}`,
          cx: 0,
          cy: 0,
          r: 1,
          gradientUnits: 'userSpaceOnUse',
          gradientTransform:
            'matrix(-11.61833 -6.43485 8.73208 -15.76606 19.515 29.653)',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.231,
          stopColor: '#0FBC5F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.312,
          stopColor: '#0FBC5F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.366,
          stopColor: '#0FBC5E',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.458,
          stopColor: '#0FBC5D',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.54,
          stopColor: '#12BC58',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.699,
          stopColor: '#28BF3C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.771,
          stopColor: '#38C02B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.861,
          stopColor: '#52C218',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.915,
          stopColor: '#67C30F',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#86C504',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_google__r_${id_17}`,
          x1: 14.791,
          y1: 25.541,
          x2: 17.709,
          y2: 25.541,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#0FBC5C',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#0CBA65',
        }),
      ),
    ),
  );
});
googleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var google = {
  category: 'brand',
  colorable: false,
  name: 'google',
  svg: googleSvg,
};
